import {
  MapNodeColumn,
  MapNodeImage,
  NodeBadge,
  NodeCaptionBlock,
  NodeSubtitle,
  NodeTitle,
} from "./ProgramMap.styles";
import { useI18n } from "../../../i18n/I18nProvider";

const BASE_NODE_SIZE = 132;

export const ProgramLevelNode = ({
  node,
  interactive,
  onClick,
  compact,
}) => {
  const { t } = useI18n();
  const size = Math.round(BASE_NODE_SIZE * (node.scale || 1) * (compact ? 0.88 : 1));
  const displayName = t(node.name || node.badge);
  const accentBadge = node.type === "finale";

  return (
    <MapNodeColumn
      $x={node.x}
      $y={node.y}
      $z={node.type === "finale" ? 3 : node.type === "trials" ? 1 : 2}
      $interactive={interactive}
      $captionWidth={node.captionWidth || 148}
    >
      {node.badge ? (
        <NodeBadge $accent={accentBadge} $tight={node.type === "trials"}>
          {t(node.badge)}
        </NodeBadge>
      ) : null}

      <MapNodeImage
        type="button"
        $size={size}
        $interactive={interactive}
        onClick={interactive ? onClick : undefined}
        aria-label={displayName}
      >
        <img src={node.image} alt={displayName} draggable={false} />
      </MapNodeImage>

      {(node.name || node.caption) && (
        <NodeCaptionBlock $width={node.captionWidth || 148}>
          {node.name ? <NodeTitle>{t(node.name)}</NodeTitle> : null}
          {node.caption ? <NodeSubtitle>{t(node.caption)}</NodeSubtitle> : null}
        </NodeCaptionBlock>
      )}
    </MapNodeColumn>
  );
};
